export default "__VITE_ASSET__50441722__"